// ----------------------------------------------------------------------

const de = {
  demo: {
    title: `Deutsch`,
    introduction: `Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie.`,
  },
  docs: {
    hi: `Hallo`,
    description: `Brauchen Sie Hilfe? \n Bitte lesen Sie unsere Dokumentation.`,
    documentation: `Dokumentation`,
  },
  app: `App`,
  user: `Benutzer`,
  list: `Liste`,
  edit: `Bearbeiten`,
  shop: `Shop`,
  blog: `Blog`,
  post: `Beitrag`,
  mail: `E-Mail`,
  chat: `Chat`,
  cards: `Karten`,
  posts: `Beiträge`,
  create: `Erstellen`,
  kanban: `Kanban`,
  general: `Allgemein`,
  banking: `Banking`,
  booking: `Buchung`,
  profile: `Profil`,
  account: `Konto`,
  product: `Produkt`,
  invoice: `Rechnung`,
  details: `Details`,
  checkout: `Kasse`,
  calendar: `Kalender`,
  analytics: `Analytics`,
  ecommerce: `E-Commerce`,
  management: `Verwaltung`,
  menu_level: `Menüebene`,
  menu_level_2a: `Menüebene 2a`,
  menu_level_2b: `Menüebene 2b`,
  menu_level_3a: `Menüebene 3a`,
  menu_level_3b: `Menüebene 3b`,
  menu_level_4a: `Menüebene 4a`,
  menu_level_4b: `Menüebene 4b`,
  item_disabled: `Eintrag deaktiviert`,
  item_label: `Eintrag Label`,
  item_caption: `Eintrag Beschriftung`,
  item_external_link: `Externer Link`,
  description: `Beschreibung`,
  other_cases: `Andere Fälle`,
  item_by_roles: `Eintrag nach Rollen`,
  only_admin_can_see_this_item: `Nur Administratoren können diesen Eintrag sehen`,

  // Quiz common translations
  quiz: {
    password: {
      title: `Passwortgeschützt`,
      description: `Bitte geben Sie das Passwort ein, um fortzufahren.`,
      label: `Passwort`,
      submit: `Entsperren`,
      invalid: `Ungültiges Passwort. Bitte versuchen Sie es erneut.`,
    },
    progress: {
      completed: `{{percentage}}% abgeschlossen`,
      questionsAnswered: `{{current}} von {{total}} Fragen beantwortet`,
      label: "Fortschritt",
    },
    navigation: {
      previous: `Zurück`,
      next: `Weiter`,
      finish: `Abschließen`,
    },
    likert: {
      stronglyDisagree: `Stimme gar nicht zu`,
      disagree: `Stimme nicht zu`,
      neutral: `Neutral`,
      agree: `Stimme zu`,
      stronglyAgree: `Stimme voll zu`,
    },
    pdf: {
      download: `Detaillierte Ergebnisse herunterladen`,
      downloading: `Wird heruntergeladen...`,
    },
    errors: {
      verificationFailed: `Passwortüberprüfung fehlgeschlagen. Bitte versuchen Sie es erneut.`,
      submissionFailed: `Ergebnisse konnten nicht übermittelt werden. Ihre Ergebnisse werden trotzdem angezeigt.`,
      loadQuestionsFailed: `Fragen konnten nicht geladen werden. Bitte versuchen Sie es erneut.`,
    },

    // Big Five specific translations
    big5: {
      password: {
        title: `Big Five Persönlichkeitstest`,
        description: `Dieser Test ist passwortgeschützt. Bitte geben Sie das Workshop-Passwort ein, um zu beginnen.`,
      },
      intro: {
        title: `Big Five Persönlichkeitstest`,
        subtitle: `BFI-2 - Big Five Inventory 2`,
        description: `Dieser Test misst fünf grundlegende Persönlichkeitsdimensionen: Extraversion, Verträglichkeit, Gewissenhaftigkeit, Neurotizismus und Offenheit für Erfahrungen. Die Ergebnisse helfen Ihnen, sich selbst besser zu verstehen.`,
        instructions: {
          title: `Anweisungen`,
          item1: `Lesen Sie jede Aussage sorgfältig durch.`,
          item2: `Bewerten Sie, inwieweit jede Aussage auf Sie zutrifft.`,
          item3: `Es gibt keine richtigen oder falschen Antworten.`,
          item4: `Antworten Sie spontan und ehrlich.`,
        },
        start: `Test starten`,
        nameLabel: `Ihr Name`,
        namePlaceholder: `Bitte geben Sie Ihren Namen ein`,
        genderLabel: `Geschlecht`,
        genderMale: `Mann`,
        genderFemale: `Frau`,
        sourceText: `Der Big Five Persönlichkeitstest ist eine wissentschaftlich weit anerkannte Methodik zur Persönlichkeitsanalyse. Weitere Informationen finden Sie unter:`,
        sourceCitation: `Danner, D., Rammstedt, B., Bluemke, M., Treiber, L., Berres, S.,
        Soto, C., & John, O. (2016). Die deutsche Version des Big Five
        Inventory 2 (BFI-2). Zusammenstellung sozialwissenschaftlicher
        Items und Skalen. doi:10.6102/zis247`,
      },
      submitting: `Ergebnisse werden ausgewertet...`,
      generatingReport: `Ihr persönlicher Bericht wird erstellt`,
      loadingQuestions: `Fragen werden geladen...`,
      results: {
        title: `Ihre Ergebnisse`,
        titlePersonalized: `Ergebnisse für {{name}}`,
        subtitle: `Hier sind Ihre Big Five Persönlichkeitsergebnisse`,
        summary: `TODO Zusammenfassung`,
        summaryText: `Ihre höchste Ausprägung zeigt sich bei {{highestTrait}} ({{highestPercentage}}. Perzentil), während {{lowestTrait}} ({{lowestPercentage}}. Perzentil) Ihre niedrigste Ausprägung ist.`,
        retake: `Test wiederholen`,
        disclaimer: `Diese Ergebnisse dienen nur zur Selbstreflexion und stellen keine professionelle psychologische Bewertung dar.`,
        detailedResults: `Die fünf Persönlichkeitsdimensionen`,
        percentileLabel: `{{percentile}}. Perzentil`,
        percentileExplanation: `Ihr Wert liegt im {{percentile}}. Perzentil für {{trait}}. In einem Raum mit 100 Personen wären {{lower}} Personen in {{trait}} höher eingestuft als Sie und {{higher}} Personen niedriger.`,
        aiInterpretation: `Interpretation`,
        aiDisclaimer: `Diese Interpretation mit Hilfe von KI generiert und dient als Orientierungshilfe. Sie ersetzt keine professionelle Beratung.`,
        aiUnavailable: `Die Interpretation ist derzeit nicht verfügbar.`,
        strengths: `Stärken`,
        developmentAreas: `Entwicklungsfelder`,
        errorTitle: `Fehler bei der Auswertung`,
        errorDescription: `Die Ergebnisse konnten nicht geladen werden. Bitte versuchen Sie es erneut.`,
      },
      traits: {
        extraversion: {
          name: `Extraversion`,
          description: `Beschreibt die Tendenz, gesellig, durchsetzungsfähig und energiegeladen zu sein. Hohe Werte deuten auf eine nach außen gerichtete, aktive Persönlichkeit hin.`,
        },
        agreeableness: {
          name: `Verträglichkeit`,
          description: `Misst die Tendenz, kooperativ, vertrauensvoll und hilfsbereit zu sein. Hohe Werte zeigen eine freundliche und rücksichtsvolle Art.`,
        },
        conscientiousness: {
          name: `Gewissenhaftigkeit`,
          description: `Bezieht sich auf Selbstdisziplin, Zuverlässigkeit und Zielorientierung. Hohe Werte deuten auf organisiertes und verantwortungsvolles Verhalten hin.`,
        },
        neuroticism: {
          name: `Neurotizismus`,
          description: `Beschreibt die Tendenz, negative Emotionen wie Angst, Traurigkeit und Reizbarkeit zu erleben. Niedrige Werte deuten auf emotionale Stabilität hin.`,
        },
        openness: {
          name: `Offenheit`,
          description: `Misst Kreativität, intellektuelle Neugier und Offenheit für neue Erfahrungen. Hohe Werte zeigen Fantasie und Wertschätzung für Kunst und Ideen.`,
        },
      },
      levels: {
        veryLow: `Sehr niedrig`,
        low: `Niedrig`,
        average: `Durchschnittlich`,
        high: `Hoch`,
        veryHigh: `Sehr hoch`,
      },
      questions: {
        q1: `Ich gehe aus mir heraus, bin gesellig.`,
        q2: `Ich bin einfühlsam, warmherzig.`,
        q3: `Ich bin eher unordentlich.`,
        q4: `Ich bleibe auch in stressigen Situationen gelassen.`,
        q5: `Ich bin nicht sonderlich kunstinteressiert.`,
        q6: `Ich bin durchsetzungsfähig, energisch.`,
        q7: `Ich begegne anderen mit Respekt.`,
        q8: `Ich bin bequem, neige zu Faulheit.`,
        q9: `Ich bleibe auch bei Rückschlägen zuversichtlich.`,
        q10: `Ich bin vielseitig interessiert.`,
        q11: `Ich schäume selten vor Begeisterung über.`,
        q12: `Ich neige dazu, andere zu kritisieren.`,
        q13: `Ich bin stetig, beständig.`,
        q14: `Ich kann launisch sein, habe schwankende Stimmungen.`,
        q15: `Ich bin erfinderisch, mir fallen raffinierte Lösungen ein.`,
        q16: `Ich bin eher ruhig.`,
        q17: `Ich habe mit anderen wenig Mitgefühl.`,
        q18: `Ich bin systematisch, halte meine Sachen in Ordnung.`,
        q19: `Ich reagiere leicht angespannt.`,
        q20: `Ich kann mich für Kunst, Musik und Literatur begeistern.`,
        q21: `Ich neige dazu, die Führung zu übernehmen.`,
        q22: `Ich habe oft Streit mit anderen.`,
        q23: `Ich neige dazu, Aufgaben vor mir herzuschieben.`,
        q24: `Ich bin selbstsicher, mit mir zufrieden.`,
        q25: `Ich meide philosophische Diskussionen.`,
        q26: `Ich bin weniger aktiv und unternehmungslustig als andere.`,
        q27: `Ich bin nachsichtig, vergebe anderen leicht.`,
        q28: `Ich bin manchmal ziemlich nachlässig.`,
        q29: `Ich bin ausgeglichen, nicht leicht aus der Ruhe zu bringen.`,
        q30: `Ich bin nicht besonders einfallsreich.`,
        q31: `Ich bin eher schüchtern.`,
        q32: `Ich bin hilfsbereit und selbstlos.`,
        q33: `Ich mag es sauber und aufgeräumt.`,
        q34: `Ich mache mir oft Sorgen.`,
        q35: `Ich weiß Kunst und Schönheit zu schätzen.`,
        q36: `Mir fällt es schwer, andere zu beeinflussen.`,
        q37: `Ich bin manchmal unhöflich und schroff.`,
        q38: `Ich bin effizient, erledige Dinge schnell.`,
        q39: `Ich fühle mich oft bedrückt, freudlos.`,
        q40: `Es macht mir Spaß, gründlich über komplexe Dinge nachzudenken und sie zu verstehen.`,
        q41: `Ich bin voller Energie und Tatendrang.`,
        q42: `Ich bin anderen gegenüber misstrauisch.`,
        q43: `Ich bin verlässlich, auf mich kann man zählen.`,
        q44: `Ich habe meine Gefühle unter Kontrolle, werde selten wütend.`,
        q45: `Ich bin nicht sonderlich fantasievoll.`,
        q46: `Ich bin gesprächig.`,
        q47: `Andere sind mir eher gleichgültig, egal.`,
        q48: `Ich bin eher der chaotische Typ, mache selten sauber.`,
        q49: `Ich werde selten nervös und unsicher.`,
        q50: `Ich finde Gedichte und Theaterstücke langweilig.`,
        q51: `In einer Gruppe überlasse ich lieber anderen die Entscheidung.`,
        q52: `Ich bin höflich und zuvorkommend.`,
        q53: `Ich bleibe an einer Aufgabe dran, bis sie erledigt ist.`,
        q54: `Ich bin oft deprimiert, niedergeschlagen.`,
        q55: `Mich interessieren abstrakte Überlegungen wenig.`,
        q56: `Ich bin begeisterungsfähig und kann andere leicht mitreißen.`,
        q57: `Ich schenke anderen leicht Vertrauen, glaube an das Gute im Menschen.`,
        q58: `Manchmal verhalte ich mich verantwortungslos, leichtsinnig.`,
        q59: `Ich reagiere schnell gereizt oder genervt.`,
        q60: `Ich bin originell, entwickle neue Ideen.`,
      },
    },
  },
};

export default de;
